import { useState } from 'react'
import { DismissibleTooltip } from '../../common/DismissibleTooltip'
import { StyledButton, StyledTrashIcon } from './styles/DeleteButtonStyles'

interface DeleteButtonProps {
  onClick: (e: React.MouseEvent) => void
  size?: number
  title?: string
  className?: string
}

/**
 * Reusable delete button component
 * Black icon by default, turns red on hover
 */
export function DeleteButton({ onClick, size = 10, title, className }: DeleteButtonProps) {
  const [isHovered, setIsHovered] = useState(false)

  const button = (
    <StyledButton
      onClick={onClick}
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <StyledTrashIcon size={size} $isHovered={isHovered} />
    </StyledButton>
  )

  if (title) {
    return (
      <DismissibleTooltip title={title} placement="top" mouseEnterDelay={0.3}>
        {button}
      </DismissibleTooltip>
    )
  }

  return button
}
